module.exports = __webpack_public_path__ + "static/media/video.43b52b44.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/colonial-kart-world/video.mp4
// module id = 813
// module chunks = 0